import './Select.css';
import type { SelectHTMLAttributes } from 'react';

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  options: Option[];
};

type Option = {
  value: string | number;
  label: string;
};

export const Select = ({ label, options, ...rest }: Props) => {
  return (
    <div className="container-select">
      <label
        htmlFor={rest.id}
        className="form-label"
        style={{ color: '#3f3f40' }}
      >
        {label}
      </label>
      <select {...rest} className="form-select">
        <option value="" key="-1">
          {''}
        </option>
        {options?.map((option: Option, index: number) => {
          return (
            <option value={option.value} key={index}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};
